module.exports = __webpack_public_path__ + "static/img/1958_05_01_TownHall_Flyer_1.761f05e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cage/archive/1958_05_01_TownHall_Flyer_1.jpg
// module id = dZyc
// module chunks = 0